import { render, staticRenderFns } from "./TrxnHistory.vue?vue&type=template&id=ce91442c"
import script from "./TrxnHistory.vue?vue&type=script&lang=ts"
export * from "./TrxnHistory.vue?vue&type=script&lang=ts"
import style0 from "./TrxnHistory.vue?vue&type=style&index=0&id=ce91442c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports